<!--
 * @Author: your name
 * @Date: 2022-01-05 12:34:31
 * @LastEditTime: 2022-02-10 17:48:52
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \management-admin\src\views\layout\BodyMain.vue
-->
<template>
  <div class="body-main">
    <div>
      <Breadcrumb v-if="system.navType === 1" />
      <NavBar v-if="system.navType === 2" />
    </div>
    <div class="content" ref="mainContent">
      <!-- :style="{ height: contentHeight + 'px', overflow: 'auto' }" -->
      <div class="content-view" :style="{ height: contentHeight + 'px' }">
        <router-view />
      </div>
      <!-- <Footer /> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Breadcrumb from "@/components/Breadcrumb.vue";
import NavBar from "@/components/NavBar.vue";
// import Footer from "./Footer.vue";
import { debounce, getViewPortHeight } from "@/utils/index.js";
export default {
  name: "BodyMain",
  data() {
    return {
      contentHeight: 0
    };
  },
  mounted() {
    this.initContentHeight();
    this.initWindowSizeEvent();

    // let element = document.querySelectorAll(".sidebar")[0];
    // this.observer = new MutationObserver((objList) => {
    //   console.log('obj List:', objList)
    //   let width = element.offsetWidth
    //   if (this.recordOldValue && width === this.recordOldValue.width) {
    //     return
    //   }
    //   this.recordOldValue = {
    //     width
    //   }
    //   console.log('obj width:', width)
    // })
    // this.observer.observe(element, { attributes: true, childList: true, subtree: true })
  },
  methods: {
    ...mapMutations(["setContentHeight", "setContentViewWidth"]),
    // 设置内容区的高度
    initContentHeight() {
      let contentTop = this.$refs.mainContent.getBoundingClientRect().top;
      this.contentHeight = getViewPortHeight() - contentTop;
      this.setContentHeight(this.contentHeight);
      this.setContentViewWidth();
    },
    // 监听窗口改变事件
    initWindowSizeEvent() {
      window.onresize = () => {
        console.log("监听到窗口变化");
        this.setResize();
      };
    },
    setResize: debounce(function() {
      this.initContentHeight();
      this.$store.commit("setWindowResize");
    }, 300)
  },
  computed: mapState(["system"]),
  components: { Breadcrumb, NavBar }
};
</script>
<style lang="scss">
@import "../../assets/css/variables.scss";
.body-main {
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #ecf0f5;
  height: calc(100vh - #{$--top-height});
  .content {
    .content-view {
      // padding: 6px;
      padding: 6px 6px 0px 6px;
      // max-height: calc(100vh - 39px - #{$--top-height});
      overflow-y: auto;
    }
  }
}
</style>
